import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";
import TokensExpiredError from "../errors/tokens-expired-error";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";

export const queryDeleteLicensedConfiguration = async (
  licensedConfigurationId: string,
) => {
  try {
    const res = await fetch(
      `${appUrl()}/api/licensed-configurations/${licensedConfigurationId}`,
      {
        method: "POST",
        headers: buildAuthenticationHeaders(),
      },
    );

    if (res.ok) {
      return res.json();
    } else if (res.status === 501) {
      const data = await res.json();

      errorSnackbar(
        data?.detail ??
          "Configuration deletion is not implemented on the backend.",
      );
    } else {
      const json = await res.json();
      if (json.message === "Refresh Token is expired") {
        throw new TokensExpiredError("All Tokens Expired");
      } else {
        throw new Error("Server Responded with 500");
      }
    }
  } catch (err) {
    if (err instanceof TokensExpiredError) {
      navigateTo(Route.TOKENS_EXPIRED_ERROR);
    } else if (err instanceof DOMException) {
      return;
    } else {
      navigateTo(Route.SERVER_ERROR);
    }
  }
};
